import { Selector } from "@ngxs/store";
import { DbVersionsState, DbVersionsStateModel, DbVersionState, LatestDbVersionStateModel } from "./dbVersion.state";

export class DbVersionGetterState {
  @Selector([DbVersionState])
  static GetLatestDbVersion(state: LatestDbVersionStateModel) {
    return state;
  }
}

export class DbVersionsGetterState {
  @Selector([DbVersionsState])
  static GetDbVersions(state: DbVersionsStateModel) {
    return state.versions;
  }
}